import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss'],
})
export class LoadingButtonComponent {
  @Input() public type: HTMLButtonElement['type'] = 'button';

  @Input() public loading = false;

  @Input() public disabled = false;

  @Input() public isPrefixIco = true;

  @Input() public icoSrc?: string;

  @Input() public buttonClass?: string;

  @Output() public handleClick = new EventEmitter<MouseEvent>();
}
